import { render } from "./HomePage.vue?vue&type=template&id=5117798c&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=5117798c&scoped=true&lang=css"

import exportComponent from "/home/regie/projects-2.0/hutts-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5117798c"]])

export default __exports__